module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cursos"
  }, [_vm._m(0), _c('div', {
    staticClass: "contenedor-scroll"
  }, _vm._l((_vm.lista), function(curso) {
    return _c('div', {
      key: curso.id,
      staticClass: "curso"
    }, [_c('div', {
      staticClass: "cabecera"
    }, [_c('div', {
      staticClass: "nombre"
    }, [_c('strong', [_vm._v(_vm._s(curso.titulo))])]), _c('div', {
      staticClass: "porcentaje"
    }, [_c('strong', [_vm._v(_vm._s(curso.progreso) + "%")])])]), _c('div', {
      staticClass: "barra"
    }, [_c('div', {
      staticClass: "avance",
      style: ({
        width: curso.progreso + '%'
      })
    })]), _c('div', {
      staticClass: "detalle"
    }, [_c('span', [_c('i', {
      staticClass: "fa fa-book"
    }), _vm._v(" " + _vm._s(curso.NumeroClases) + " Clases")]), _c('span', {
      class: _vm.estadoClass(curso.progreso)
    }, [_vm._v(_vm._s(_vm.estado(curso.progreso)))])]), _c('div', {
      staticClass: "detalle margin-top-6"
    }, [_vm._m(1, true), _c('span', [_vm._v(_vm._s(curso.DuracionTotal))])]), _c('button', {
      staticClass: "btn-continuar",
      on: {
        "click": function($event) {
          return _vm.continuar(curso.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-play"
    }), _vm._v("Continuar")])])
  }), 0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "titulo"
  }, [_c('span', [_vm._v("📚 Mis cursos")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" Duracion")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24c10d8e","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/kpis/c_kpi_cursos.vue
// module id = 841
// module chunks = 0